import dynamic from 'next/dynamic';
import { Builder } from '@builder.io/sdk';

const Hero = dynamic(() => import('./Hero'));

const HeroConfig = {
  name: 'Hero',
  friendlyName: 'Hero',
  inputs: [
    {
      name: 'text',
      type: 'string',
    },
  ],
  defaultStyles: {
    margin: '0',
  },
};

Builder.registerComponent(Hero, HeroConfig);
